import React from 'react';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import { useToast } from '@chakra-ui/react';
import UsersManagementFormUI from '@Modules/admin/users/components/formsUI/UsersManagementFormUI';
import UsersMangementFormMeta from './UsersManagementFormMeta';

type Props = {
  closeModal: any,
};

export default React.forwardRef(function UsersManagementFormHanlder(
  { closeModal }: Props,
  ref
) {
  const formRef = React.useRef<any>(null);
  const toast = useToast();

  const { isLoading, mutate } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      closeModal();
      toast({
        position: 'top-right',
        title: 'User profile createds successfully',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const onSubmit = (data: any) => {
    // console.log('DATA: ', data);
    mutate(data);
  };

  const triggerSubmit = () => {
    const form = formRef?.current;
    if (form) {
      // console.log(form);
      form?.submitBtnRef?.current?.click();
    }
  };

  React.useImperativeHandle(ref, () => ({
    triggerSubmit,
    isLoading,
  }));

  return (
    <>
      <UsersManagementFormUI
        ref={formRef}
        isLoading={isLoading}
        meta={UsersMangementFormMeta}
        onSubmit={onSubmit}
      />
    </>
  );
});
